module.exports = __webpack_public_path__ + "static/media/vueweather.589f24e1.png";